type Noop = () => void;
type AsyncNoop = () => Promise<void>;

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop: Noop = () => {};

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const asyncNoop: AsyncNoop = async () => {};

export default noop;